<template>
  <v-toolbar fixed flat color="white">
    <div>
      <v-img :src="`${publicPath}images/logo/TMX_logo.png`" height="48" width="101" @click="$router.push('/')" style="cursor: pointer;"/>
    </div>
    <!--v-toolbar-title @click="$router.push('/')" style="cursor: pointer;">
      //
    </v-toolbar-title-->
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <template v-for="(item, index) in $store.state.mainMenu.mainMenu">
        <fragment v-if="!item.children || item.children.length === 0" :key="index">
          <v-btn text @click="onItemClick(item)" color="primary">
            {{ $t(`${item.text}`) }}
          </v-btn>
        </fragment>
        <fragment v-else-if="item.children && item.children.length > 0" :key="index">
          <v-menu offset-y transition="scroll-y-transition" open-on-hover>
            <template v-slot:activator="{ on }">
              <v-btn text :key="index" color="primary" v-on="on">
                {{ $t(`${item.text}`) }}
              </v-btn>
            </template>
            <v-list>
              <template v-for="(item, index) in item.children">
                <v-list-item v-show="!(item.text === 'mainNavBar.jobOffers' && $i18n.locale !== 'hu-HU')" :key="index" @click="$router.push(item.path)">
                  <v-list-item-title>
                    {{ $t(`${item.text}`) }}
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </fragment>
      </template>
      <v-btn icon @click="toggleSnackBar">
        <v-icon color="primary">
          mdi-information
        </v-icon>
      </v-btn>
    </v-toolbar-items>
    <v-snackbar v-model="showSnackbar" absolute right top :timeout="5000" color="white" style="margin-top: 60px;">
      <div class="text--primary pa-2" style="max-width: 320px;">
        <p class="subtitle-1 font-weight-bold">
          {{ $t('infoPopup.title')}}
        </p>
        <p class="body-2">
          {{ $t('infoPopup.content1') }} <a href="https://mobilfutar.tmx.hu" target="_blank"><b>{{ $t('mobilfutar') }}</b></a> {{ $t('infoPopup.content2') }}
        </p>
        <p>
          {{ $t('infoPopup.hashTags') }}
        </p>
      </div>
    </v-snackbar>
  </v-toolbar>
</template>

<script>
import languageChangeDropdown from './languageChangeDropdown.vue';

export default {
  name: 'mainNavBar',
  components: {
    languageChangeDropdown,
  },
  beforeMount() {
    this.lang = this.$i18n.locale;
  },
  data() {
    return {
      lang: '',
      showSnackbar: false,
    };
  },
  methods: {
    infoClick() {
      this.$emit('info-click');
    },
    toggleSnackBar() {
      this.showSnackbar = true;
    },
    onItemClick(item) {
      const cn = this.$store.getters.getCampaignName;
      if (item.externalLink) {
        if (cn === 'A52S') {
          window.open(`${item.route2}`, '_blank');
        } else {
          window.open(`${item.route1}`, '_blank');
        }
      } else {
        this.$router.push(`${item.route}`);
      }
    },
  },
};
</script>

<style scoped>

</style>
